(() => {
  // Deterministic barcode drawn from the shipment number
  document.querySelectorAll("[data-barcode]").forEach((svg) => {
    let seed = 7;
    for (const ch of svg.dataset.barcode) seed = (seed * 31 + ch.charCodeAt(0)) >>> 0;
    const rnd = () => (seed = (seed * 1664525 + 1013904223) >>> 0) / 4294967296;
    let x = 0;
    let out = "";
    const bar = (w) => {
      out += `<rect x="${x.toFixed(2)}" y="0" width="${w.toFixed(2)}" height="40"/>`;
      x += w;
    };
    bar(1.6); x += 1; bar(0.8); x += 1.4;
    while (x < 176) {
      bar(0.7 + Math.floor(rnd() * 3) * 0.75);
      x += 0.8 + Math.floor(rnd() * 3) * 0.7;
    }
    x += 0.6; bar(0.8); x += 1; bar(1.6);
    svg.setAttribute("viewBox", `0 0 ${x.toFixed(2)} 40`);
    svg.innerHTML = out;
  });

  // Parcel tilts gently toward the pointer
  const parcel = document.querySelector(".parcel");
  if (parcel && matchMedia("(hover: hover) and (prefers-reduced-motion: no-preference)").matches) {
    addEventListener("pointermove", (e) => {
      const r = parcel.getBoundingClientRect();
      const dx = (e.clientX - (r.left + r.width / 2)) / innerWidth;
      const dy = (e.clientY - (r.top + r.height / 2)) / innerHeight;
      parcel.style.setProperty("--ry", `${(-17 + dx * 16).toFixed(2)}deg`);
      parcel.style.setProperty("--rx", `${(9 - dy * 12).toFixed(2)}deg`);
    }, { passive: true });
  }

  // Footer wordmark fills the full width
  const giant = document.querySelector(".giant");
  const fit = () => {
    if (!giant) return;
    giant.style.fontSize = "100px";
    const w = giant.parentElement.clientWidth;
    giant.style.fontSize = `${(100 * w) / giant.getBoundingClientRect().width}px`;
  };
  fit();
  addEventListener("resize", fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
})();
